<template>
<div class="f-l fdqy-b" style="height: 60px;position: relative;color: #562409;">
	<div class="fs16" style="margin-bottom: 2px;width: 50px;text-align: center;">
		<p>{{mouth}}/{{day}}</p>
	</div>
	<div class="f-l fdqx-c fdqy-c fs30 mb15" style="width: 100px;z-index: 2;font-weight: 500;">
		<p>{{hour}}</p>
		<p style="width: 15px;text-align: center;"><span v-if="sce%2===0">:</span></p>
		<p>{{min}}</p>
	</div>
	<div class="fs16" style="margin-bottom: 2px;width: 55px;text-align: center;">
		<p>星期{{week}}</p>
	</div>
	<div style="position: absolute;width: 106px;height: 106px;border-radius: 50%;background: #fff;border: 2px solid #e49536;z-index: 1;top: -40px;left: 45px;"></div>
</div>
</template>

<script>
	export default {
		data(){
			return {
				year:2016,
				mouth:"06",
				day:"01",
				hour:"12",
				min:"00",
				sce:0,
				week:"三"
			}
		},
		created(){
			setInterval(()=>{
				let t=this.getTime()
				this.year=t.year
				this.mouth=t.mouth
				this.day=t.day
				this.hour=t.hour
				this.min=t.min
				this.sce=t.sce
				this.week=t.week
			},1000)
		}
	}
</script>

<style scoped>
</style>